import React from 'react';
import { useAppDispatch } from 'redux/store';

import {
  resetAiSuggestComponentsState,
  setNovoAIShowGenerateModal,
} from 'redux/actions/lecture-pages';

import { hideAddUI } from 'lecture_pages/templates/components/nv-add-component';
import AiGeneratingModalContent from './ai-generating-modal-content';
import AiModal from './ai-modal';

type AiGeneratingModalProps = {
  showModal: boolean,
};

const AiGeneratingModal = (props: AiGeneratingModalProps) => {
  const { showModal } = props;
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(setNovoAIShowGenerateModal(false));
    dispatch(resetAiSuggestComponentsState());
    hideAddUI(dispatch);
  };

  return (
    <AiModal
      show={showModal}
      onClose={onClose}
      body={<AiGeneratingModalContent closeModal={onClose} />}
    />
  );
};

export default AiGeneratingModal;

